import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link as Scroll } from "react-scroll";
import { Link } from "react-router-dom";

// import { Link } from 'react-router-dom'

import menu_br from "../resources/br/menu.js";
import menu_es from "../resources/es/menu.js";
import menu_en from "../resources/en/menu.js";

// npm install --save-dev @iconify/react @iconify/icons-jam

class NavBar extends Component {
  constructor(props) {
    super(props);

    this.textsNavBar = { en: menu_en, br: menu_br, es: menu_es }; // Textos da Navbar de acordo com a linguagem
    let storedLang = JSON.parse(localStorage.getItem("language"));
    const availableLanguages =
      process.env.REACT_APP_AVAILABLE_LANGUAGES.split(" ");
    this.currentLanguage =
      storedLang && availableLanguages.includes(storedLang.lang)
        ? storedLang.lang
        : process.env.REACT_APP_DEFAULT_LANGUAGE;
    this.availableLanguagesUrls =
      process.env.REACT_APP_AVAILABLE_LANGUAGES.split(" ").map((lang) => {
        return "/" + lang;
      });

    this.state = {
      style: {
        header:
          window.scrollY >= 50
            ? "navbar fixed-top p-0 lev-fixed-header"
            : "navbar fixed-top p-0",
        // button: props.rightButton ? `btn btn-sm btn-${props.rightButton.color} ml-auto` : "btn btn-sm btn-light ml-auto"
        button: props.rightButton
          ? `btn btn-sm btn-${props.rightButton.color}`
          : "btn btn-sm btn-light",
        iconsClass:
          window.location.pathname === "/" + this.currentLanguage ||
          window.location.pathname === "/carreiras"
            ? "social-icons"
            : "social-icons light-bg",
      },
      showContactModal: false,
      showMobileMenu: true,
      mobileMenuClass: "collapse navbar-collapse w-100",
    };
  }

  async componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  homeButton = () => {
    window.location.pathname !== "/" + this.currentLanguage
      ? (window.location.pathname = "/")
      : (window.location.href = "#");
  };

  handleScroll = () => {
    if (
      window.scrollY >= 50 ||
      window.location.pathname === "/" + this.currentLanguage + "/contato"
    ) {
      this.setState({
        style: {
          header: "navbar fixed-top p-0 lev-fixed-header",
          // button: "btn btn-sm btn-primary ml-auto"
          button: "btn btn-sm btn-primary",
          iconsClass: "social-icons light-bg scrolled",
        },
      });
    } else {
      this.setState({
        style: {
          header: "navbar fixed-top p-0",
          // button: this.props.rightButton ? `btn btn-sm btn-${this.props.rightButton.color} ml-auto` : "btn btn-sm btn-light ml-auto"
          button: this.props.rightButton
            ? `btn btn-sm btn-${this.props.rightButton.color}`
            : "btn btn-sm btn-light",
          iconsClass: "social-icons",
        },
      });
    }
  };

  handleMobileMenu = () => {
    const { showMobileMenu } = this.state;

    if (showMobileMenu) {
      this.setState({
        showMobileMenu: !showMobileMenu,
        mobileMenuClass: "collapse navbar-collapse w-100 show lev-mobile-menu",
      });
    } else {
      this.setState({
        showMobileMenu: !showMobileMenu,
        mobileMenuClass:
          "collapse navbar-collapse w-100 show lev-mobile-menu lev-change-mobile-menu",
      });
    }
  };

  render() {
    const { style, mobileMenuClass } = this.state;
    const { rightButton } = this.props;
    let { language } = this.props;
    language = language ? language : this.currentLanguage;

    return (
      <>
        <header className={style.header}>
          <nav className="notranslate navbar-expand-sm w-100">
            <div translate="no" className="notranslate lev-navbar-container">
              <div translate="no" className="notranslate navbar-brand d-flex">
                <img
                  className="notranslate mr-auto align-middle"
                  src="/images/brand/levty-logo.svg"
                  alt="LEVTY"
                  onClick={this.homeButton}
                />
              </div>
              {/* <div   translate="no" className="notranslate navbar-toggler ml-auto">
                <a   translate="no" href="https://www.linkedin.com/company/levty/" target="_blank" rel="noopener noreferrer"> <Icon icon={linkedinSquare} color="#0494db" width="25" height="25" /> </a>
                <a   translate="no" href="https://www.instagram.com/levtysistemas/" target="_blank" rel="noopener noreferrer"> <Icon icon={instagramIcon} color="#0494db" width="25" height="25" /> </a>
                <a   translate="no" href="https://www.facebook.com/levtytech/" target="_blank" rel="noopener noreferrer"> <Icon icon={facebookSquare} color="#0494db" width="25" height="25" /> </a>
              </div> */}

              <button
                className="notranslate btn btn-sm btn-light navbar-toggler ml-auto"
                type="button"
                onClick={this.handleMobileMenu}
              >
                <img
                  src="/images/icons/menu.svg"
                  alt=""
                  width="24"
                  height="24"
                />
              </button>

              <div
                translate="no"
                className="notranslate d-none d-sm-flex w-100"
              >
                {/* <a   translate="no" className="notranslate btn btn-sm btn-link ml-sm-4 ml-md-5" href="/">Home</a> */}
                {/* <Scroll
                className="notranslate navbar-brand d-flex"
                to="lev-section-pricing"
                offset={100}
                duration={1000}
                smooth={true}
                >
                <a   translate="no" className="notranslate btn btn-sm btn-link" href="/"  onClick={this.planButton} >Planos</a>
                </Scroll> */}

                {!this.availableLanguagesUrls.find(
                  (path) => path === window.location.pathname
                ) ? (
                  <Link
                    className="notranslate btn btn-sm btn-link"
                    to={{
                      pathname: "/" + this.currentLanguage,
                      state: { otherPage: true },
                    }}
                  >
                    {" "}
                    {this.textsNavBar[language].button.plans}{" "}
                  </Link>
                ) : (
                  <div translate="no" className="notranslate lev-scrl-ctn">
                    <Scroll
                      className="notranslate btn btn-sm btn-link"
                      to="lev-section-pricing"
                      offset={42}
                      duration={1000}
                      smooth={true}
                    >
                      {" "}
                      {this.textsNavBar[language].button.plans}{" "}
                    </Scroll>
                  </div>
                )}
                {language === "br" && (
                  <Link
                    className="notranslate btn btn-sm btn-link"
                    to="/carreiras"
                  >
                    Carreiras
                  </Link>
                )}
                <a
                  translate="no"
                  href={process.env.REACT_APP_ENV_URL + "/br/blog"}
                  className="notranslate btn btn-sm btn-link"
                  rel="noopener noreferrer"
                >
                  Blog
                </a>

                <Link
                  translate="no"
                  className="notranslate btn btn-sm btn-link"
                  to="/carreiras/trainee"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Trainee 2025
                </Link>

                {/* <a   translate="no" className="notranslate btn btn-sm btn-link" href="/central-do-cliente">Central do Cliente</a> */}
                <div
                  translate="no"
                  className={"ml-auto mt-2 pr-2 " + style.iconsClass}
                >
                  {/* <a   translate="no" href="https://www.linkedin.com/company/levty/" target="_blank" rel="noopener noreferrer"> <Icon icon={linkedinSquare} className="notranslate icon" width="35" height="35" /> </a>
                  <a   translate="no" href="https://www.instagram.com/levtysistemas/" target="_blank" rel="noopener noreferrer"> <Icon icon={instagramIcon} className="notranslate first icon" width="35" height="35" /> </a>
                  <a   translate="no" href="https://www.facebook.com/levtytech/" target="_blank" rel="noopener noreferrer"> <Icon icon={facebookSquare} className="notranslate icon" width="35" height="35" /> </a> */}
                </div>

                {rightButton && (
                  <button
                    id="lev-header-cta"
                    type="button"
                    className={style.button}
                    data-toggle="modal"
                    data-target="#contactModal"
                    onClick={rightButton.onClick}
                  >
                    {rightButton.label}
                  </button>
                )}
              </div>
            </div>
            <div translate="no" className="notranslate d-sm-none">
              <div
                translate="no"
                className={mobileMenuClass}
                id="navbarTogglerDemo02"
              >
                <div
                  translate="no"
                  className="notranslate container-fluid w-100 px-3 pb-3"
                >
                  {/* <a   translate="no" className="notranslate btn btn-sm btn-link ml-sm-4 ml-md-5 pl-0 w-100 text-left" href="/">Home</a> */}
                  {/* <Scroll
                    className="notranslate navbar-brand d-flex"
                    to="lev-section-pricing"
                    duration={1000}
                    smooth={true}
                  >
                    <a   translate="no" className="notranslate btn btn-sm btn-link pl-0 w-100 text-left" href="/" onClick={this.handleMobileMenu}>Planos</a>
                  </Scroll> */}
                  {!this.availableLanguagesUrls.find(
                    (path) => path === window.location.pathname
                  ) ? (
                    <Link
                      className="notranslate btn btn-sm btn-link pl-0 w-100 text-left"
                      to={{
                        pathname: "/" + this.currentLanguage,
                        state: { otherPage: true },
                      }}
                    >
                      {" "}
                      {this.textsNavBar[language].button.plans}{" "}
                    </Link>
                  ) : (
                    <div translate="no" className="notranslate lev-scrl-ctn">
                      <Scroll
                        className="notranslate btn btn-sm btn-link pl-0 w-100 text-left"
                        to="lev-section-pricing"
                        offset={42}
                        duration={1000}
                        smooth={true}
                      >
                        {" "}
                        {this.textsNavBar[language].button.plans}{" "}
                      </Scroll>
                    </div>
                  )}
                  {language === "br" && (
                    <Link
                      className="notranslate btn btn-sm btn-link pl-0 w-100 text-left"
                      to="/carreiras"
                    >
                      {this.textsNavBar[language].button.career}
                    </Link>
                  )}
                  <a
                    translate="no"
                    href={process.env.REACT_APP_ENV_URL + "/br/blog"}
                    className="notranslate btn btn-sm btn-link pl-0 w-100 text-left"
                    rel="noopener noreferrer"
                  >
                    Blog
                  </a>

                  {/* {
                    links.map((item, index) => <a   translate="no" key={index} className="notranslate btn btn-sm btn-link pl-0 w-100 text-left" href={item.link}>{item.label}</a>)
                  } */}
                  {rightButton && (
                    <button
                      type="button"
                      className="notranslate btn btn-sm btn-link pl-0 w-100 text-left"
                      onClick={rightButton.onClick}
                    >
                      {rightButton.label}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </nav>
        </header>
      </>
    );
  }
}

NavBar.propTypes = {
  rightButton: PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    color: PropTypes.oneOf(["primary", "light", "link"]),
  }),
};

export default NavBar;
